import { useLegacyEffect } from "helper/customHook";
import { SCREEN } from "helper/roleChecker/Screens";
import Calendar from "modules/DeclareLeave/components/CustomCalendarTimeKeeping";
import AttendanceDetailsModal from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/AttendanceDetailsModal";
import {
  getTimeCheckingStart,
  setMonthYearTimeChecking,
} from "modules/DeclareLeave/redux/getTimeKeeping";
import { selectTimeCheckingData } from "modules/DeclareLeave/redux/selector";
import moment from "moment";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { CalendarWrapper } from "../../style";
import SendFeedback from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/SendFeedback";
import ResponseDetails from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/ResponseDetail";
import { deleteRequestStart } from "modules/DeclareLeave/redux/deleteRequest";
import { ConfirmModal } from "components/common/ConfirmModal";
import pxToRem from "theme/base/pxToRem";

export const TimeKeeping = () => {
  const dispatch = useDispatch();

  const data = useSelector(selectTimeCheckingData);

  const fetchData = useCallback(
    (time?: string) => {
      const month = time ? moment(time).month() + 1 : moment().month() + 1;
      const year = time ? moment(time).year() : moment().year();
      const id = `${year}-${month}`;

      dispatch(
        getTimeCheckingStart({
          id,
          month,
          year,
          screenCode: SCREEN.IP_015,
        })
      );
    },
    [dispatch]
  );

  const handleMonthChange = useCallback(
    (time) => {
      dispatch(
        setMonthYearTimeChecking({
          month: moment(time).month() + 1,
          year: moment(time).year(),
        })
      );
      fetchData(time);
    },
    [dispatch, fetchData]
  );

  useLegacyEffect(() => {
    fetchData();
  }, []);

  const deleteRequest = () => {
    dispatch(
      deleteRequestStart({
        tab: "feedback",
        screenCode: SCREEN.IP_016,
        callback: fetchData,
      })
    );
  };

  return (
    <>
      <CalendarWrapper>
        <Calendar
          sx={{
            width: "100%",
          }}
          isDisabledWeekend
          onMonthChange={(props) => handleMonthChange(props)}
          highlightedDays={data}
        />
      </CalendarWrapper>
      <AttendanceDetailsModal />
      <SendFeedback />
      <ResponseDetails />
      <Outlet />
      <ConfirmModal
        title="Bạn có muốn xóa đơn này"
        styleTitle={{
          width: pxToRem(270),
        }}
        buttonApprove="Xóa đơn"
        buttonReject="Hủy"
        buttonApproveProps={{
          color: "error",
        }}
        buttonRejectProps={{
          variant: "blur",
          sx: {
            backgroundColor: "#E6E6E6",
            color: "#000000",
          },
        }}
        onApprove={deleteRequest}
      />
    </>
  );
};
